export const clear_short_error_action = () =>dispatch => {

    dispatch({type:'CLEAR_SHORT_ERROR_ALERT', payload:false})
}

export const post_short_alert_message = (message) => dispatch => {

    if (message.error) dispatch({type:"SHORT_ERROR_ALERT", payload:message})
    else dispatch({type:"SHORT_SUCCESS_ALERT", payload:message})
}


export function handleError(error) {
    let errorMessage = 'An error occurred. Please try again later.';
  
    if (error.response) {
      // The request was made and the server responded with a status code
      if ([401, 403].includes(error.response.status)) {
        errorMessage = 'Unauthorized/Forbidden';
      } else if (error.response.status === 404) {
        errorMessage = 'Resource not found';
      } else if (error.response.status >= 500) {
        errorMessage = 'Internal server error';
      }
    } else if (error.request) {
      // The request was made but no response was received
      errorMessage = 'No response from server';
    } else {
      // Something happened in setting up the request that triggered an error
      errorMessage = error.message;
    }
  
    return errorMessage;
  }

